export default "__VITE_PUBLIC_ASSET__40adc8b6__"